/** The element carrying the server's query cache to the browser. */
export const STATE_ELEMENT_ID = "__listou_state";
